import { Phone, ArrowRight, Star, Award } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import heroBg from "@/assets/hero-bg.jpg";

const badges = [
  { icon: Star, label: "5-Star Reviews" },
  { icon: Award, label: "NM-Licensed" },
];

const HeroSection = () => (
  <section
    id="home"
    className="relative min-h-screen flex items-center justify-center overflow-hidden"
    aria-label="Hero"
  >
    <img
      src={heroBg}
      alt="Albuquerque homes with professional roofing and solar panels installed by Zenith Solutions"
      className="absolute inset-0 w-full h-full object-cover"
      loading="eager"
      width={1920}
      height={1080}
    />
    <div className="absolute inset-0 hero-gradient" />

    <div className="relative z-10 container mx-auto px-4 py-32 text-center max-w-4xl">
      <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}>
        <div className="flex flex-wrap justify-center gap-4 mb-8">
          {badges.map((b) => (
            <span
              key={b.label}
              className="inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wider text-white/90 bg-white/10 border border-white/25 rounded-full px-4 py-1.5 backdrop-blur-sm"
            >
              <b.icon className="h-3.5 w-3.5" aria-hidden="true" /> {b.label}
            </span>
          ))}
        </div>

        <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black leading-[1.1] text-white mb-6 drop-shadow-lg">
          Albuquerque's #1 Roofing Company & Solar Experts
        </h1>

        <p className="text-lg md:text-xl text-white/85 max-w-2xl mx-auto mb-10 leading-relaxed drop-shadow-md">
          Top-rated roof replacement, solar panel installation, and home construction in Albuquerque, NM. Owens Corning
          Preferred Contractor with industry-leading warranties. Get your <strong className="text-white">FREE</strong>{" "}
          estimate today.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a href="tel:5056048536" aria-label="Call Now (505) 604-8536">
            <Button
              size="lg"
              className="bg-primary text-primary-foreground hover:bg-primary/90 text-base font-bold h-14 px-8 gap-2 w-full sm:w-auto shadow-lg"
            >
              <Phone className="h-5 w-5" aria-hidden="true" /> Call Now (505) 604-8536
            </Button>
          </a>
          <Link to="/get-estimate" aria-label="Free Quote Form">
            <Button
              size="lg"
              className="bg-white/15 border-2 border-white/40 text-white hover:bg-white/25 hover:text-white text-base font-bold h-14 px-8 gap-2 w-full sm:w-auto backdrop-blur-sm"
            >
              Free Quote Form <ArrowRight className="h-5 w-5" aria-hidden="true" />
            </Button>
          </Link>
        </div>
      </motion.div>
    </div>
  </section>
);

export default HeroSection;
